import { Controller } from '@hotwired/stimulus';

// Blocs selon un choix (cibles choice : boutons radio ou liste) : seul le
// bloc dont `data-reveal-for` contient la valeur choisie (valeurs séparées
// par des espaces) est affiché ; les autres sont masqués et leurs champs
// désactivés (non envoyés) ; sans choix, tous.
export default class extends Controller {
    static targets = ['choice', 'block'];

    connect() {
        this.apply();
    }

    apply() {
        const value = this.value;
        this.blockTargets.forEach((block) => {
            const shown = value !== null && block.dataset.revealFor.split(' ').includes(value);
            block.hidden = !shown;
            block.querySelectorAll('input, select, textarea').forEach((field) => { field.disabled = !shown; });
        });
    }

    get value() {
        const choice = this.choiceTargets.find((target) => target.type !== 'radio' || target.checked);
        return choice ? choice.value : null;
    }
}
